module.exports = __webpack_public_path__ + "img/servicebg.32935f9b.png";